import { MetaIcon, LinkedInIcon, XIcon, YoutubeIcon } from '../../../Constants/Icons';
import { legalLinks, termsOfServiceUrl } from '../../../Constants/Data';

const Legal = () => {
    const currentYear = new Date().getFullYear();
    return (
        <div className="w-full mx-auto flex flex-col bg-charmPurple px-10 md:px-8 1.5xl:px-[104px]  2xl:px-28 3xl:px-64 pb-14">
            <div className="hidden mt-12 lg:flex flex-row  justify-between md:border-b-4  md:border-charmBorder md:pb-28 gap-4 lg:pb-10">
                <div className="flex flex-col items-start gap-2">
                    <p className="font-proximanova text-[18px]  text-charmOrange font-[600]">Products</p>
                    {legalLinks.filter(item => item.category === 'Products').map((item, index) => (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" className="mt-1 text-white font-proximanova text-[18px]  text-left" style={{ textDecoration: 'none' }}>
                            {item.name}
                        </a>
                    ))}
                </div>

                <div className="flex flex-col items-start gap-2">
                    <p className="font-proximanova text-[18px]  text-charmOrange font-[600]">Specialties</p>
                    {legalLinks.filter(item => item.category === 'Specialties').map((item, index) => (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" className="mt-1 text-white font-proximanova text-[18px]  text-left" style={{ textDecoration: 'none' }}>
                            {item.name}
                        </a>
                    ))}
                </div>

                <div className="flex flex-col items-start gap-2">
                    <p className="font-proximanova text-[18px]  text-charmOrange font-[600]">Services</p>
                    {legalLinks.filter(item => item.category === 'Services').map((item, index) => (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" className="mt-1 text-white font-proximanova text-[18px]  text-left" style={{ textDecoration: 'none' }}>
                            {item.name}
                        </a>
                    ))}
                </div>

                <div className="flex flex-col items-start gap-2">
                    <p className="font-proximanova text-[18px]  text-charmOrange font-[600]">Company</p>
                    {legalLinks.filter(item => item.category === 'Company').map((item, index) => (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" className="mt-1 text-white font-proximanova text-[18px]  text-left" style={{ textDecoration: 'none' }}>
                            {item.name}
                        </a>
                    ))}
                </div>

                <div className="flex flex-col items-start gap-2">
                    <p className="font-proximanova text-[18px]  text-charmOrange font-[600]">Learn</p>
                    {legalLinks.filter(item => item.category === 'Learn').map((item, index) => (
                        <a href={item.link} target="_blank" rel="noopener noreferrer" className="mt-1 text-white font-proximanova text-[18px]  text-left" style={{ textDecoration: 'none' }}>
                            {item.name}
                        </a>
                    ))}
                </div>

            </div>

            <div className="flex flex-col items-center xl:hidden">
                <button className="pt-8 w-40 md:mx-auto">
                    <img src="https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/charmhealth-logo.png" alt="Charm Health" />
                </button>

                <p className="mt-6 font-proximanova text-[18px]  text-white md:text-center">©{currentYear} MedicalMine Inc. All rights reserved.</p>
            </div>

            <div className="lg:mt-4 flex flex-col md:flex-row gap-3 md:gap-1 md:gap-0 md:justify-between items-center">
                <button className="hidden xl:block w-40 md:mx-auto">
                    <img src="https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/charmhealth-logo.png" alt="Charm Health" />
                </button>

                <button className="hidden xl:block font-proximanova text-[18px]  text-white  md:text-center">©{currentYear} MedicalMine Inc. All rights reserved.</button>

                <a href={termsOfServiceUrl} target="_blank" rel="noopener noreferrer" className="w-fit md:mx-auto">
                    <button className="font-proximanova text-[18px]  w-fit text-white">Terms of Service</button>
                </a>
                <div className="hidden md:block bg-white w-[1px] h-4"></div>


                <a href="https://www.charmhealth.com/privacy-policy.html" target="_blank" rel="noopener noreferrer" className="w-fit md:mx-auto">
                    <button className="font-proximanova text-[18px]  w-fit text-white">Privacy Policy</button>
                </a>
                <div className="hidden md:block bg-white w-[1px] h-4"></div>

                <a href="https://www.charmhealth.com/security.html" target="_blank" rel="noopener noreferrer" className="w-fit md:mx-auto">
                    <button className="font-proximanova text-[18px]  w-fit text-white">Security Policy</button>
                </a>
                <div className="hidden md:block bg-white w-[1px] h-4"></div>

                <a href="https://www.charmhealth.com/anti-spam-policy.html" target="_blank" rel="noopener noreferrer" className="w-fit md:mx-auto">
                    <button className="font-proximanova text-[18px]  w-fit text-white">Anti-Spam Policy</button>
                </a>
                <div className="hidden md:block bg-white w-[1px] h-4"></div>

                <a href="https://www.charmhealth.com/cookie-policy.html" target="_blank" rel="noopener noreferrer" className="w-fit md:mx-auto">
                    <button className="font-proximanova text-[18px]  w-fit text-white">Cookie Policy</button>
                </a>
            </div>

            <div className="mt-8 w-full flex justify-center">
                <div className=" flex flex-row gap-6 w-fit md:mx-auto items-center">
                    <a href="https://www.facebook.com/charmhealth" target="_blank" rel="noopener noreferrer">
                        <MetaIcon />
                    </a>

                    <a href="https://www.linkedin.com/company/charmhealth" target="_blank" rel="noopener noreferrer" className="" >
                        <LinkedInIcon />
                    </a>

                    <a href="https://x.com/charmhealth" target="_blank" rel="noopener noreferrer" className="">
                        <XIcon />
                    </a>

                    <a href="https://www.youtube.com/charmhealth" target="_blank" rel="noopener noreferrer" className="">
                        <YoutubeIcon />
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Legal;